import { render, staticRenderFns } from "./HeadlineEdit.vue?vue&type=template&id=015831aa&"
import script from "./HeadlineEdit.vue?vue&type=script&lang=js&"
export * from "./HeadlineEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports